<script>
import options from './DictionaryList.options'
export default options
</script>

<template>
  <div v-if="showFilter" class="kb-dictionary-list__filter">
    <template
      v-for="(letter, letterindex) in startLettersDisplay"
      :key="letterindex"
    >
      <button
        :class="letter.selected"
        @click="filterOnLetter(letter.letter)"
        :disabled="letter.disabled"
      >
        {{ letter.letter }}
      </button>
    </template>
  </div>
  <div
    class="kb-dictionary-list__group"
    v-for="(group, index) in displayList"
    :key="index"
  >
    <dt
      class="kb-dictionary-list__group__letter"
      :id="`letter-${group.letter}`"
    >
      {{ group.letter }}
    </dt>
    <template v-for="(word, wordindex) in group.words" :key="wordindex">
      <dd class="kb-dictionary-list__group__word">
        <a :href="word.href">
          {{ word.word }}
          <div class="kb-ui-icon kb-ui-icon--ui-link"></div>
        </a>
      </dd>
    </template>
  </div>
  <template v-if="!displayList.length">
    <div class="kb-dictionary-list__no-results">
      <h2>{{ getLabel('noResultTitle') }}</h2>
      <p class="kb-dictionary-list__no-results__summary">
        {{ getLabel('noResultDesc') }}
      </p>
      <a
        v-if="getLabel('noResultButtonHref')"
        :href="getLabel('noResultButtonHref')"
        class="kb-button kb-button--full-color-spot"
        >{{ getLabel('noResultButtonText') }}</a
      >
    </div>
  </template>
</template>
